<template>
  <div style="height: 410px; width: 100%">
    <l-map :zoom="zoom" :center="center" :options="mapOptions" style="height: 80%">
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="center" />
    </l-map>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
  name: "Map",
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data() {
    return {
      zoom: 14,
      center: latLng(32.484154, 34.988391),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5
      }
    };
  }
};
</script>
